import { RegistrationError } from 'WebmcpCore/errors';
import type { ConsentDuration, SurfaceTier, ToolTier, WebMcpToolDefinition } from 'WebmcpCore/types';

export interface ConsentPolicy {
  duration: ConsentDuration;
  requiresConsent: boolean;
}

export function resolveConsentPolicy(input: { surface: SurfaceTier; tool: WebMcpToolDefinition }): ConsentPolicy {
  const { surface, tool } = input;
  const toolTier: ToolTier = tool.tier;

  if (surface === 'read-only') {
    if (toolTier === 'read') return { duration: 'session', requiresConsent: false };
    throw new RegistrationError(`Cannot register a user-scoped or admin tool '${tool.name}' on a read-only surface`);
  }

  if (toolTier === 'read') return { duration: 'session', requiresConsent: false };
  if (toolTier === 'user-scoped') return { duration: 'session', requiresConsent: true };
  return { duration: 'invocation', requiresConsent: true };
}
